import { API_BASE_URL } from "@/api/api.config";
import useRestQuery from "@/remoteState/useRestQuery";

const useStudentQuizGet = (levelId) => {
  const params = { associated_content_id: levelId };
  const queryString = new URLSearchParams(params).toString();
  const resource = `${API_BASE_URL}/api/v3/studentquiz/?${queryString}`;
  return useRestQuery(resource, { skip: !levelId });
};

export default useStudentQuizGet;
